import { useMemo } from "react";
import weightMetric from "config/metrics/weight";
import useChartSelections from "components/charting/hooks/useChartSelections";
import type { ExerciseMetric } from "types";
import { MetadataType } from "types/metadata";

function useOneRepMaxChartWeightMetric(): ExerciseMetric {
  const selections = useChartSelections();
  const measure = selections.measures[0];

  return useMemo(() => {
    if (measure?.type !== MetadataType.EXERCISE) return weightMetric;
    return measure.metadata.metrics.find((metric) => metric.field === "weight") ?? weightMetric;
  }, [measure]);
}

export default useOneRepMaxChartWeightMetric;
